import { useState, useEffect, useRef } from 'react';

const ServicesSection = () => {
  const [visibleCards, setVisibleCards] = useState<boolean[]>([false, false, false]);
  const sectionRef = useRef<HTMLDivElement>(null);

  const services = [
    {
      icon: 'ri-user-search-line',
      title: '구인·구직 광고',
      description: '박스/실장/가게 구인 전용 광고페이지 제작. 빠른 인력 충원을 위한 효과적인 디자인.',
      features: ['전문 디자이너 맞춤 제작', '모바일 최적화', '빠른 제작 (2-3일)'],
      price: '5만원부터',
      color: 'neon-pink',
    },
    {
      icon: 'ri-global-line',
      title: '홍보 웹사이트',
      description: '손님 유입과 브랜드 이미지 구축을 위한 전문 홈페이지. 업체의 가치를 높이는 프리미엄 웹사이트.',
      features: ['업체 맞춤형 디자인', 'SEO 최적화', '문의 폼 연동'],
      price: '10만원부터',
      color: 'navy',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            services.forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => {
                  const newState = [...prev];
                  newState[index] = true;
                  return newState;
                });
              }, index * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">전문 서비스</h2>
          <p className="text-gray-600 text-lg">
            유흥업계에 특화된 맞춤형 디자인 솔루션을 제공합니다
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer group ${
                visibleCards[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="w-16 h-16 bg-neon-light rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-neon-pink`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-3 group-hover:text-neon-pink transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-neon-pink"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
